module.exports = __webpack_public_path__ + "img/abstract-shapes-18-reverse.4a644847.svg";